import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
/**
 * Getters
 */
export const _PartnerGetter = Getter.of();
export const _PartnerResponseGetter = Getter.of();
export const _PartnersGetter = Getter.of();
export const _PartnersResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _PartnersResponse2Partners = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _Partner2Data = Fold.compose(_PartnerGetter, Res._Response());
export const _Partners2Data = Fold.compose(_PartnersGetter, Res._Response());
export const _Partner2Attributes = Fold.compose(_Partner2Data, Lens.prop("attributes"));
export const _Partners2Attributes = Fold.compose(_Partners2Data, Fold._each(), Lens.prop("attributes"));
export const _PartnersAttributes2Name = Fold.compose(_Partners2Attributes, Lens.prop("name"));
export const _PartnersAttributes2LogoUrl = Fold.compose(_Partners2Attributes, Lens.prop("logoUrl"));
export const _PartnersAttributes2HelpUrl = Fold.compose(_Partners2Attributes, Lens.prop("helpUrl"));
export const _PartnersAttributes2HomeUrl = Fold.compose(_Partners2Attributes, Lens.prop("homeUrl"));
export const _PartnersAttributes2DisplayPriority = Fold.compose(_Partners2Attributes, Lens.prop("displayPriority"));
export const _PartnersAttributes2TransparentLogoUrl = Fold.compose(_Partners2Attributes, Lens.prop("transparentLogoUrl"));

